import { render, staticRenderFns } from "./CentralPain.vue?vue&type=template&id=67702205&scoped=true"
import script from "./CentralPain.vue?vue&type=script&lang=js"
export * from "./CentralPain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67702205",
  null
  
)

export default component.exports